export default require("./node_modules/agora-rtc-sdk-ng/AgoraRTC_N-production.js");